import $ from "jquery";
const proLink = require('./proLink');
const {trackGa, track} = require('./analytics/analytics');

(function () {

  $(document).ready(function() {

    if (window.location.pathname.includes('sales-estimator')) {

      proLink.init();

      const data = {
        COM: [
          ["Amazon Launchpad", "/img/new/estimator-amazon_launchpad.svg"],
          ["Appliances", "/img/new/estimator-washing-machine.svg"],
          ["Arts, Crafts & Sewing", "/img/new/estimator-painting.svg"],
          ["Automotive", "/img/new/estimator-jeep.svg"],
          ["Baby", "/img/new/estimator-baby.svg"],
          ["Beauty & Personal Care", "/img/new/estimator-perfume.svg"],
          ["Books", "/img/new/estimator-book.svg"],
          ["Camera & Photo", "/img/new/estimator-photo-camera.svg"],
          ["Cell Phones & Accessories", "/img/new/estimator-phone.svg"],
          ["Clothing, Shoes & Jewelry", "/img/new/estimator-shirt.svg"],
          ["Collectible Coins", "/img/new/estimator-collectible-coins.svg"],
          ["Computers & Accessories", "/img/new/estimator-computer.svg"],
          ["Electronics", "/img/new/estimator-pendrive.svg"],
          ["Everything Else", "/img/new/estimator-else.svg"],
          ["Grocery & Gourmet Food", "/img/new/estimator-sale.svg"],
          ["Health & Household", "/img/new/estimator-health.svg"],
          ["Home and Garden", "/img/new/estimator-house.svg"],
          ["Home & Kitchen", "/img/new/estimator-cithen.svg"],
          ["Home Improvement", "/img/new/estimator-home_improvement.svg"],
          ["Industrial & Scientific", "/img/new/estimator-robot-arm.svg"],
          ["Jewelry", "/img/new/estimator-diamond.svg"],
          ["Kindle Store", "/img/new/estimator-tablet.svg"],
          ["Kitchen & Dining", "/img/new/estimator-cutlery.svg"],
          ["Musical Instruments", "/img/new/estimator-balalaika.svg"],
          ["Office Products", "/img/new/estimator-folder.svg"],
          ["Paid in Kindle Store", "/img/new/estimator-paid_in_kindle_store.svg"],
          ["Patio, Lawn & Garden", "/img/new/estimator-acanthaceae.svg"],
          ["Pet Supplies", "/img/new/estimator-cat.svg"],
          ["Shoes", "/img/new/estimator-converse.svg"],
          ["Software", "/img/new/estimator-web.svg"],
          ["Sports & Outdoors", "/img/new/estimator-walk.svg"],
          ["Tools & Home Improvement", "/img/new/estimator-improvement.svg"],
          ["Toys & Games", "/img/new/estimator-baby-mobile.svg"],
          ["Watches", "/img/new/estimator-wristwatch.svg"],
          ["Video Games", "/img/new/estimator-game-console.svg"]
        ],
        CO_UK: [
          ["Baby", "/img/new/estimator-baby.svg"],
          ["Beauty", "/img/new/estimator-perfume.svg"],
          ["Car & Motorbike", "/img/new/estimator-jeep.svg"],
          ["Clothing", "/img/new/estimator-shirt.svg"],
          ["Computers", "/img/new/estimator-computer.svg"],
          ["DIY & Tools", "/img/new/estimator-improvement.svg"],
          ["DVD & Blu-ray", "/img/new/estimator-dvd.svg"],
          ["Electronics", "/img/new/estimator-pendrive.svg"],
          ["Garden & Outdoors", "/img/new/estimator-house.svg"],
          ["Grocery", "/img/new/estimator-sale.svg"],
          ["Health & Personal Care", "/img/new/estimator-health.svg"],
          ["Home & Kitchen", "/img/new/estimator-cithen.svg"],
          ["Jewellery", "/img/new/estimator-diamond.svg"],
          ["Kitchen & Home", "/img/new/estimator-kitchen-home.svg"],
          ["Large Appliances", "/img/new/estimator-washing-machine.svg"],
          ["Lighting", "/img/new/estimator-lighting.svg"],
          ["Luggage", "/img/new/estimator-laggage.svg"],
          ["Music", "/img/new/estimator-music.svg"],
          ["Musical Instruments", "/img/new/estimator-balalaika.svg"],
          ["Office Products", "/img/new/estimator-folder.svg"],
          ["PC & Video Games", "/img/new/estimator-game-console.svg"],
          ["Pet Supplies", "/img/new/estimator-cat.svg"],
          ["Shoes", "/img/new/estimator-converse.svg"],
          ["Software", "/img/new/estimator-web.svg"],
          ["Sports & Outdoors", "/img/new/estimator-walk.svg"],
          ["Stationery & Office Supplies", "/img/new/estimator-folder.svg"],
          ["Toys & Games", "/img/new/estimator-baby-mobile.svg"],
          ["Watches", "/img/new/estimator-wristwatch.svg"]
        ],
        CA: [
          ["Automotive", "/img/new/estimator-jeep.svg"],
          ["Baby", "/img/new/estimator-baby.svg"],
          ["Beauty & Personal Care", "/img/new/estimator-perfume.svg"],
          ["Books", "/img/new/estimator-book.svg"],
          ["Clothing & Accessories", "/img/new/estimator-shirt.svg"],
          ["Electronics", "/img/new/estimator-pendrive.svg"],
          ["Grocery & Gourmet Food", "/img/new/estimator-sale.svg"],
          ["Health & Personal Care", "/img/new/estimator-health_personal_care.svg"],
          ["Home", "/img/new/estimator-simple_home.svg"],
          ["Home & Kitchen", "/img/new/estimator-cithen.svg"],
          ["Industrial & Scientific", "/img/new/estimator-robot-arm.svg"],
          ["Jewelry", "/img/new/estimator-diamond.svg"],
          ["Luggage & Bags", "/img/new/estimator-luggage_bags.svg"],
          ["Music", "/img/new/estimator-music.svg"],
          ["Musical Instruments, Stage & Studio", "/img/new/estimator-game-console.svg"],
          ["Office Products", "/img/new/estimator-folder.svg"],
          ["Patio, Lawn & Garden", "/img/new/estimator-acanthaceae.svg"],
          ["Pet Supplies", "/img/new/estimator-cat.svg"],
          ["Shoes & Handbags", "/img/new/estimator-converse.svg"],
          ["Sports & Outdoors", "/img/new/estimator-walk.svg"],
          ["Tools & Home Improvement", "/img/new/estimator-improvement.svg"],
          ["Toys & Games", "/img/new/estimator-baby-mobile.svg"],
          ["Watches", "/img/new/estimator-wristwatch.svg"]
        ],
        DE: [
          ["Auto & Motorrad", "/img/new/estimator-jeep.svg"],
          ["Baby", "/img/new/estimator-baby.svg"],
          ["Baumarkt", "/img/new/estimator-baumarkt.svg"],
          ["Beauty", "/img/new/estimator-perfume.svg"],
          ["Bekleidung", "/img/new/estimator-shirt.svg"],
          ["Beleuchtung", "/img/new/estimator-lighting.svg"],
          ["Bücher", "/img/new/estimator-book.svg"],
          ["Bürobedarf & Schreibwaren", "/img/new/estimator-folder.svg"],
          ["Computer & Zubehör", "/img/new/estimator-computer.svg"],
          ["DVD & Blu-ray", "/img/new/estimator-dvd.svg"],
          ["Drogerie & Körperpflege", "/img/new/estimator-health.svg"],
          ["Elektro-Großgeräte", "/img/new/estimator-pendrive.svg"],
          ["Elektronik & Foto", "/img/new/estimator-pendrive.svg"],
          ["Games", "/img/new/estimator-game-console.svg"],
          ["Garten", "/img/new/estimator-house.svg"],
          ["Gewerbe, Industrie & Wissenschaft", "/img/new/estimator-robot-arm.svg"],
          ["Haustier", "/img/new/estimator-cat.svg"],
          ["Kamera & Foto", "/img/new/estimator-photo-camera.svg"],
          ["Koffer, Rucksäcke & Taschen", "/img/new/estimator-luggage_bags.svg"],
          ["Küche & Haushalt", "/img/new/estimator-cithen.svg"],
          ["Küche, Haushalt & Wohnen", "/img/new/estimator-kuche_haushalt_wohnen.svg"],
          ["Lebensmittel & Getränke", "/img/new/estimator-lebensmittel_getranke.svg"],
          ["Musik-CDs & Vinyl", "/img/new/estimator-balalaika.svg"],
          ["Musikinstrumente & DJ-Equipment", "/img/new/estimator-balalaika.svg"],
          ["Schmuck", "/img/new/estimator-diamond.svg"],
          ["Schuhe & Handtaschen", "/img/new/estimator-converse.svg"],
          ["Software", "/img/new/estimator-web.svg"],
          ["Spielzeug", "/img/new/estimator-baby-mobile.svg"],
          ["Sport & Freizeit", "/img/new/estimator-walk.svg"],
          ["Uhren", "/img/new/estimator-wristwatch.svg"]
        ],
        FR: [
          ["Animalerie", "/img/new/estimator-cat.svg"],
          ["Auto et Moto", "/img/new/estimator-jeep.svg"],
          ["Bagages", "/img/new/estimator-laggage.svg"],
          ["Beauté et Parfum", "/img/new/estimator-perfume.svg"],
          ["Bijoux", "/img/new/estimator-diamond.svg"],
          ["Bricolage", "/img/new/estimator-bricol.svg"],
          ["Bébés & Puériculture", "/img/new/estimator-baby.svg"],
          ["Chaussures et Sacs", "/img/new/estimator-converse.svg"],
          ["Commerce, Industrie & Science", "/img/new/estimator-robot-arm.svg"],
          ["Cuisine & Maison", "/img/new/estimator-cutlery.svg"],
          ["DVD & Blu-ray", "/img/new/estimator-dvd.svg"],
          ["Epicerie", "/img/new/estimator-sale.svg"],
          ["Fournitures de bureau", "/img/new/estimator-folder.svg"],
          ["Gros électroménager", "/img/new/estimator-pendrive.svg"],
          ["High-Tech", "/img/new/estimator-computer.svg"],
          ["Hygiène et Soins du corps", "/img/new/estimator-health.svg"],
          ["Informatique", "/img/new/estimator-informatique.svg"],
          ["Instruments de musique", "/img/new/estimator-balalaika.svg"],
          ["Jardin", "/img/new/estimator-acanthaceae.svg"],
          ["Jeux et Jouets", "/img/new/estimator-baby-mobile.svg"],
          ["Jeux vidéo", "/img/new/estimator-game-console.svg"],
          ["Livres anglais et étrangers", "/img/new/estimator-book.svg"],
          ["Livres", "/img/new/estimator-book.svg"],
          ["Logiciels", "/img/new/estimator-web.svg"],
          ["Luminaires et Eclairage", "/img/new/estimator-lighting.svg"],
          ["Montres", "/img/new/estimator-wristwatch.svg"],
          ["Sports et Loisirs", "/img/new/estimator-walk.svg"],
          ["Vêtements et accessoires", "/img/new/estimator-shirt.svg"]
        ],
        ES: [
          ["Bebé", "/img/new/estimator-baby.svg"],
          ["Belleza", "/img/new/estimator-perfume.svg"],
          ["Bricolaje y herramientas", "/img/new/estimator-improvement.svg"],
          ["Coche y moto", "/img/new/estimator-jeep.svg"],
          ["Deportes y aire libre", "/img/new/estimator-walk.svg"],
          ["Electrónica", "/img/new/estimator-pendrive.svg"],
          ["Equipaje", "/img/new/estimator-laggage.svg"],
          ["Hogar y cocina", "/img/new/estimator-cithen.svg"],
          ["Iluminación", "/img/new/estimator-lighting.svg"],
          ["Industria, empresas y ciencia", "/img/new/estimator-robot-arm.svg"],
          ["Informática", "/img/new/estimator-informatique.svg"],
          ["Instrumentos musicales", "/img/new/estimator-balalaika.svg"],
          ["Jardín", "/img/new/estimator-acanthaceae.svg"],
          ["Joyería", "/img/new/estimator-diamond.svg"],
          ["Juguetes y juegos", "/img/new/estimator-baby-mobile.svg"],
          ["Libros", "/img/new/estimator-book.svg"],
          ["Oficina y papelería", "/img/new/estimator-folder.svg"],
          ["Películas y TV", "/img/new/estimator-tv.svg"],
          ["Relojes", "/img/new/estimator-wristwatch.svg"],
          ["Ropa", "/img/new/estimator-shirt.svg"],
          ["Salud y cuidado personal", "/img/new/estimator-health.svg"],
          ["Software", "/img/new/estimator-web.svg"],
          ["Videojuegos", "/img/new/estimator-game-console.svg"],
          ["Zapatos y complementos", "/img/new/estimator-converse.svg"]
        ],
        IT: [
          ["Abbigliamento", "/img/new/estimator-shirt.svg"],
          ["Alimentari e cura della casa", "/img/new/estimator-house.svg"],
          ["Auto e Moto", "/img/new/estimator-jeep.svg"],
          ["Bellezza", "/img/new/estimator-perfume.svg"],
          ["Cancelleria e prodotti per ufficio", "/img/new/estimator-folder.svg"],
          ["Casa e cucina", "/img/new/estimator-cutlery.svg"],
          ["Commercio, Industria e Scienza", "/img/new/estimator-robot-arm.svg"],
          ["Elettronica", "/img/new/estimator-pendrive.svg"],
          ["Fai da te", "/img/new/estimator-painting.svg"],
          ["Film e TV", "/img/new/estimator-tv.svg"],
          ["Giardino e giardinaggio", "/img/new/estimator-acanthaceae.svg"],
          ["Giochi e giocattoli", "/img/new/estimator-baby-mobile.svg"],
          ["Gioielli", "/img/new/estimator-diamond.svg"],
          ["Illuminazione", "/img/new/estimator-lighting.svg"],
          ["Informatica", "/img/new/estimator-informatique.svg"],
          ["Libri", "/img/new/estimator-book.svg"],
          ["Orologi", "/img/new/estimator-wristwatch.svg"],
          ["Prima infanzia", "/img/new/estimator-kid-and-baby.svg"],
          ["Salute e cura della persona", "/img/new/estimator-health.svg"],
          ["Scarpe e borse", "/img/new/estimator-converse.svg"],
          ["Software", "/img/new/estimator-web.svg"],
          ["Sport e tempo libero", "/img/new/estimator-walk.svg"],
          ["Strumenti musicali e DJ", "/img/new/estimator-balalaika.svg"],
          ["Valigeria", "/img/new/estimator-laggage.svg"],
          ["Videogiochi", "/img/new/estimator-game-console.svg"]
        ],
        IN: [
          ["Baby", "/img/new/estimator-baby.svg"],
          ["Bags, Wallets & Luggage", "/img/new/estimator-luggage_bags.svg"],
          ["Beauty", "/img/new/estimator-perfume.svg"],
          ["Books", "/img/new/estimator-book.svg"],
          ["Car & Motorbike", "/img/new/estimator-jeep.svg"],
          ["Clothing & Accessories", "/img/new/estimator-shirt.svg"],
          ["Electronics", "/img/new/estimator-pendrive.svg"],
          ["Gift Cards", "/img/new/estimator-card.svg"],
          ["Grocery & Gourmet Foods", "/img/new/estimator-grocery_gourmet_foods.svg"],
          ["Health & Personal Care", "/img/new/estimator-health.svg"],
          ["Home & Kitchen", "/img/new/estimator-cithen.svg"],
          ["Industrial & Scientific", "/img/new/estimator-robot-arm.svg"],
          ["Jewellery", "/img/new/estimator-diamond.svg"],
          ["Movies & TV Shows", "/img/new/estimator-tv.svg"],
          ["Music", "/img/new/estimator-music.svg"],
          ["Musical Instruments", "/img/new/estimator-balalaika.svg"],
          ["Office Products", "/img/new/estimator-folder.svg"],
          ["Pet Supplies", "/img/new/estimator-cat.svg"],
          ["Shoes & Handbags", "/img/new/estimator-converse.svg"],
          ["Software", "/img/new/estimator-web.svg"],
          ["Sports, Fitness & Outdoors", "/img/new/estimator-walk.svg"],
          ["Toys & Games", "/img/new/estimator-baby-mobile.svg"],
          ["Video Games", "/img/new/estimator-game-console.svg"],
          ["Watches", "/img/new/estimator-wristwatch.svg"]
        ],
        COM_MX: [
          ["Bebé", "/img/new/estimator-baby.svg"],
          ["Deportes y Aire Libre", "/img/new/estimator-walk.svg"],
          ["Electrónicos", "/img/new/estimator-pendrive.svg"],
          ["Herramientas y Mejoras del Hogar", "/img/new/estimator-improvement.svg"],
          ["Hogar y Cocina", "/img/new/estimator-cithen.svg"],
          ["Juegos y juguetes", "/img/new/estimator-baby-mobile.svg"],
          ["Oficina y Papelería", "/img/new/estimator-folder.svg"],
          ["Ropa, Zapatos y Accesorios", "/img/new/estimator-shirt.svg"],
          ["Salud, Belleza y Cuidado Personal", "/img/new/estimator-health.svg"],
          ["Videojuegos", "/img/new/estimator-game-console.svg"]
        ]
      };

      const salesEstimator = document.getElementById('salesEstimator-behavior');
      const marketplace = document.getElementById('salesEstimator-marketplace');
      const categoryList = document.getElementById('salesEstimator-category');
      const currentMarketPlace = document.getElementById('salesEstimator-currentMarketplace');
      const currentCategory = document.getElementById('salesEstimator-currentCtegory');
      const calculatorValue = document.getElementById('salesEstimator-value');
      const estimatorCalc = document.querySelector('.salesEstimator-calculator__calc');
      const calcBtn = estimatorCalc.querySelector('button');
      const estimatorData = document.getElementById('salesEstimator-behavior_data');
      const estimatorError = document.getElementById('salesEstimator-behavior_error');
      const chatButton = document.getElementById('chatButton');

      let domain = 'COM';
      const getCategoryData = () => data[domain][0];
      let category = getCategoryData();
      let rank;

      const clearView = () => {
        Array.from(salesEstimator.getElementsByClassName('opened')).forEach(e => e.classList.remove('opened'));
      }

      const updateSelect = (txt, url, taget) => {
        category = taget == currentCategory ? [txt, ""] : getCategoryData();
        taget.innerHTML = `<img src=${url}>${txt}`;
      }

      const getPathName = (link) => {
        const reg = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/;
        return reg.exec(link)[1];
      }

      const categoryRender = () => {
        const dataAr = data[domain].map((e) => {
          return `<li><img src=${e.length > 0 ? e[1] : ""} alt="">${e[0]}</li>`;
        })
        categoryList.innerHTML = dataAr.join('');
      }

      const calculation = () => {
        pause();
        $.get($MAIN_HOST + '/api/v1/landing/sales?domain=' + domain + '&category=' + encodeURIComponent(category[0]) + '&rank=' + rank)
          .then((response) => {
            trackGa("calculate", "Estimator", "button");
            displayResult(response.sales);
          })
          .catch((err) => {
            track("Estimator", "blocked", "button");
            trackGa("blocked", "Estimator", "button");
            displayError('Limit has been reached, please try again in ');
        })
      }

      categoryRender();
      updateSelect(category[0], category[1], currentCategory);

      //End Initiating

      // Timer
      const initializeClock = (id, endtime) => {
        let seconds = endtime;
        block();
        const clock = document.getElementById(id);
        const secondsSpan = clock.querySelector('.seconds');
        function updateClock() {
          secondsSpan.innerHTML = (seconds);
          if (seconds <= 0) {
            clearInterval(timeinterval);
            pause();
            unBlock();
          }
          seconds--;
        }
        updateClock();
        let timeinterval = setInterval(updateClock, 1000);
      }
      // End Timer

      const displayResult = (res) => {
        estimatorData.innerHTML = `<p>${res}</p>`;
        calcBtn.classList.remove('disabled');
      }

      const displayError = (res) => {
        estimatorError.innerHTML = `<p class="salesEstimator-calculator__calc-alert" id="countdown">${res} <span class="seconds"></span> seconds.</p>`;
        calcBtn.classList.remove('disabled');
        estimatorError.parentElement.style.display = "block";
        initializeClock('countdown', 60);
      }

      const block = () => {
        calculatorValue.value = "";
        calcBtn.classList.add('disabled');
        calcBtn.disabled = true;
      }

      const unBlock = () => {
        calculatorValue.value = "";
        calcBtn.disabled = false;
        estimatorError.parentElement.style.display = "none";
      }

      const pause = () => {
        estimatorData.innerHTML = `<img src="/img/new/estimator-quesition.svg" alt="">`;
        calcBtn.classList.add('disabled');
      }

      //Behaviors

      document.getElementById('iClose').addEventListener('click', () => {
        const iframe = document.getElementById('iVideo');
        const src = iframe.src;
        iframe.src = "";
        iframe.src = src;
      });

      salesEstimator.addEventListener('click', (e) => {
        const currentClassList = e.target.classList;
        if (currentClassList.contains('salesEstimator-calculator_radio')) {
          // clearView();
          const nextClassList = e.target.nextElementSibling.classList;
          if (currentClassList.contains('opened')) {
            currentClassList.remove('opened');
            nextClassList.remove('opened');
          } else {
            currentClassList.add('opened');
            nextClassList.add('opened');
          }
        } else if (e.target.parentElement.classList.contains('close')) {
          clearView();
        }
      });

      marketplace.addEventListener('click', (e) => {
        if (e.target.tagName === "LI") {
          const txt = e.target.textContent;
          domain = e.target.querySelector('img').dataset.marketplace;
          const url = getPathName(e.target.querySelector('img').src);
          updateSelect(txt, url, currentMarketPlace);
          updateSelect(category[0], category[1], currentCategory);
          categoryRender();
          clearView();
        }
      });

      categoryList.addEventListener('click', (e) => {
        if (e.target.tagName === "LI") {
          const txt = e.target.textContent;
          const url = getPathName(e.target.querySelector('img').src);
          updateSelect(txt, url, currentCategory);
          clearView();
          $('#calculator_category').modal('hide');
        }
      });

      currentCategory.addEventListener('click', () => {
        clearView();
      });

      calculatorValue.addEventListener('input', () => {
        let val = calculatorValue.value;
        if (val.length > 0 && val !== '0') {
          !calcBtn.disabled && calcBtn.classList.remove('disabled');
          rank = val.replace(/[ ,. -]/g, "");
        } else {
          calcBtn.classList.add('disabled');
        }
      });

      calcBtn.addEventListener('click', () => {
        calculation();
      });

      chatButton.addEventListener('click', () => $zopim.livechat.window.show());

      //End Behaviors
    }
  });

}());
